/**
 * CPV-AI-01 · "Ask CPV": the top bar's way into the assistant, beside the location selector. It opens the workspace
 * with the context of the page the person is on (product, plan, parameter or signal — askContext.contextOfPage).
 * Shown only when the server says the person holds POLICY cpv.ai.use (useAssistantAllowed), and not on the workspace itself.
 */
import React from 'react';
import { Button } from 'antd';
import { Sparkles } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ASSISTANT } from '@/components/cpv-ui/tokens';
import useAssistantAllowed from './useAssistantAllowed';
import { WORKSPACE, contextOfPage, workspacePath } from './askContext';

export default function AskCpvButton() {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const allowed = useAssistantAllowed();
  if (!allowed || pathname.startsWith(WORKSPACE)) return null;
  return (
    <Button icon={<Sparkles size={ASSISTANT.icon} aria-hidden />} onClick={() => navigate(workspacePath(contextOfPage(pathname, search)))}
      data-testid="ask-cpv">
      Ask CPV
    </Button>
  );
}
